function SPC_00(inp_d){
  document.getElementById("spc_load_pap").className = "spc_load_vis";
  if(document.getElementById(inp_d).getAttribute("type") == "radio"){
    RDOCHK(inp_d);
  };
  var inp_list = document.getElementById("SPC-inp_list").getElementsByClassName("SPC-CB");
  var inp_pl = "";
  var upd_pr = location.search;
  var upd_hst = "https://" + location.hostname;
  for(var L = 0;L < inp_list.length;L++){
    var color_cnf = inp_list[L].getAttribute("data-clrpick");
    if(inp_list[L].checked == true && color_cnf == null){
      inp_pl = inp_pl + inp_list[L].getAttribute("data-cbtag") + ",";
    };
  };
  var color_inp_list = document.querySelectorAll(".SPC-CB[data-clrpick='true']");
  var color_pl = "";
  for(var L = 0;L < color_inp_list.length;L++){
    if(color_inp_list[L].checked == true){
      color_pl = color_inp_list[L].getAttribute("data-cbtag").replace(/=/g, ",");
      var L = color_inp_list.length;
    };
  };
  if(document.querySelectorAll(".SPC-CB[data-clrpick='false']")[0].checked == true){var color_pl = "";};
  if(document.getElementById("SPC-cb_clear-sort_field_inp")){
    if(document.getElementById("SPC-cb_clear-sort_field_inp").checked == true){var color_pl = "";var inp_pl = "";cbunchk();};
  };  
  if(inp_pl != "" || color_pl != ""){
    var upd_lnk_pre = document.getElementById("upd_lnk_SPC").getAttribute("data-upd_lnk") + "/" + upd_pr;
    const url_cnt = new URL(upd_hst + upd_lnk_pre);
    const url_PRM = url_cnt.searchParams;
    url_PRM.delete('page');
    url_PRM.delete("filter.p.m.custom.prd_tags")
    url_PRM.delete("filter.v.option.カラー")
    if(url_PRM.toString() !== ""){
      if(inp_pl != ""){
        var upd_lnk = url_cnt.href + "&filter.p.m.custom.prd_tags=" + inp_pl;
        if(color_pl != ""){
          var upd_lnk = upd_lnk + "&filter.v.option.カラー=" + color_pl;
        };
      }else{
        var upd_lnk = url_cnt.href + "&filter.v.option.カラー=" + color_pl;
      };
    }else{
      if(inp_pl != ""){
        var upd_lnk = url_cnt.href + "?filter.p.m.custom.prd_tags=" + inp_pl;
        if(color_pl != ""){
          var upd_lnk = upd_lnk + "&filter.v.option.カラー=" + color_pl;
        };
      }else{
        var upd_lnk = url_cnt.href + "?filter.v.option.カラー=" + color_pl;
      };
    };    
  }else{
    var upd_lnk = document.getElementById("upd_lnk_SPC").getAttribute("data-upd_lnk") + upd_pr;
    const url_cnt = new URL(upd_hst + upd_lnk);
    const url_PRM = url_cnt.searchParams;
    url_PRM.delete("filter.p.m.custom.prd_tags")
    url_PRM.delete("filter.v.option.カラー")
    var upd_lnk = url_cnt.href;
  };
  jQuery.ajax({type: 'GET',url: upd_lnk})
  .then(
    function(data){
      var $prd_lst = $(data);
      var pgC_TB = $prd_lst.find(".collection__toolbar")[0];
      document.getElementsByClassName("collection__toolbar")[0].getElementsByClassName("collection__toolbar-item--count")[0].getElementsByClassName("collection__showing-count")[0].textContent = pgC_TB.getElementsByClassName("collection__toolbar-item--count")[0].getElementsByClassName("collection__showing-count")[0].textContent;
      var pld_item_list = $prd_lst.find(".product-list--collection")[0];
      var pld_non_item = $prd_lst.find(".empty-state")[0];
      var pgnt = $prd_lst.find(".pagination")[0];
      if(document.getElementsByClassName("product-list--collection")[0]){
        document.getElementsByClassName("product-list--collection")[0].remove();
      };
      if(document.getElementsByClassName("empty-state")[0]){
        document.getElementsByClassName("empty-state")[0].remove();
      };
      if(document.getElementsByClassName("pagination")[0]){
        document.getElementsByClassName("pagination")[0].remove();
      };
      if(document.querySelectorAll(".SPC-cb_prnt[data-cbcnf='rw_spc']")[0]){
        document.querySelectorAll(".SPC-cb_prnt[data-cbcnf='rw_spc']")[0].remove();
      };
      if(document.querySelectorAll(".SPC-cb_prnt[data-cbcnf='rw_clr']")[0]){
        document.querySelectorAll(".SPC-cb_prnt[data-cbcnf='rw_clr']")[0].remove();
      };
      if($prd_lst.find(".SPC-cb_prnt[data-cbcnf='rw_spc']")[0]){
        var nw_pld_rw_spc_item = CRT_MK($prd_lst.find(".SPC-cb_prnt[data-cbcnf='rw_spc']")[0]);
        document.querySelectorAll(".SPC-cb_ttl[data-cbcnf='rw_spc']")[0].after(nw_pld_rw_spc_item);
      };
      if($prd_lst.find(".SPC-cb_prnt[data-cbcnf='rw_clr']")[0]){
        var nw_pld_rw_clr_item = CRT_MK($prd_lst.find(".SPC-cb_prnt[data-cbcnf='rw_clr']")[0]);
        document.querySelectorAll(".SPC-cb_ttl[data-cbcnf='rw_clr']")[0].after(nw_pld_rw_clr_item);
      };
      if($prd_lst.find(".SPC-cb_clear-sort_field")[0]){
        if(!document.querySelectorAll(".SPC-cb_clear-sort_field")[0]){
          var nw_spc_srt_clear_cnt = CRT_MK($prd_lst.find(".SPC-cb_clear-sort_field")[0]);
          document.querySelectorAll(".rw_sort_tgl_main")[0].after(nw_spc_srt_clear_cnt);
        };
      }else{
        if(document.querySelectorAll(".SPC-cb_clear-sort_field")[0]){
          document.querySelectorAll(".SPC-cb_clear-sort_field")[0].remove();
        };
      };
      if(pld_item_list){
        var nw_prd_item = CRT_MK(pld_item_list);
        document.getElementsByClassName("collection__toolbar")[0].after(nw_prd_item);
      };
      if(pld_non_item){
        var non_prd_cnt = CRT_MK(pld_non_item);
        document.getElementsByClassName("collection__toolbar")[0].after(non_prd_cnt);
      };
      if(pgnt){
        var nw_pgnt = CRT_MK(pgnt);
        var pgnt_lnk = nw_pgnt.getElementsByTagName("a");
        for(var a = 0;a < pgnt_lnk.length;a++){
          pgnt_lnk[a].removeAttribute("data-page");
        };
        document.getElementsByClassName("product-list--collection")[0].after(nw_pgnt);
      };
      window.history.pushState(null, '', upd_lnk);
      document.getElementById("spc_load_pap").className = "spc_load_hid";
    }
  )
  .fail(
    function(data){
      console.log(data);
      if(document.getElementsByClassName("product-list--collection")[0]){document.getElementsByClassName("product-list--collection")[0].remove();};
      if(document.getElementsByClassName("collection")[0].getElementsByClassName("pagination")[0]){document.getElementsByClassName("collection")[0].getElementsByClassName("pagination")[0].remove();};
      if(document.getElementsByClassName("empty-state")[0]){document.getElementsByClassName("empty-state")[0].remove();};
      const fail_emp = document.createElement("div");
      fail_emp.setAttribute("class","empty-state empty-state--tight");
      const emp_txt = document.createElement("p");
      emp_txt.setAttribute("class","emp_cnt_msg")
      emp_txt.textContent = "ページ情報の取得に失敗しました。恐れ入りますが、ページ更新後に再度お試しください。";
      fail_emp.appendChild(emp_txt);
      document.getElementsByClassName("collection__toolbar")[0].after(fail_emp);
      document.getElementById("spc_load_pap").className = "spc_load_hid";
    }
  )
};

function CRT_MK(Nd_d_v) {
  const newElement = document.createElement(Nd_d_v.tagName);
  if (Nd_d_v.attributes) {
    for(var n = 0;n < Nd_d_v.attributes.length;n++){
      var Pnd_n = Nd_d_v.attributes[n].name;
      var Pnd_v = Nd_d_v.attributes[n].value;
      newElement.setAttribute(Pnd_n, Pnd_v);
    };
  };
  if (Nd_d_v.textContent) {
    if(Nd_d_v.childNodes[0].nodeType == 3 && Nd_d_v.className != "visually-hidden"){
      if(Nd_d_v.className == "product-item__title text--strong link"){
        newElement.textContent = Nd_d_v.childNodes[0].nodeValue;
        /*const PSbrnk = document.createElement("br");
        newElement.appendChild(PSbrnk);
        const ttlnd = document.createTextNode(Nd_d_v.childNodes[2].nodeValue)
        newElement.appendChild(ttlnd);*/
      }else if(Nd_d_v.className == "price"){
        const vhid = document.createElement("span");
        vhid.setAttribute("class","visually-hidden");
        vhid.textContent = "販売価格"
        newElement.appendChild(vhid);
        const ndprice = Nd_d_v.getElementsByClassName("visually-hidden")[0].nextSibling.nodeValue;
        const ttlnd = document.createTextNode(ndprice);
        newElement.appendChild(ttlnd);
      }else{
        newElement.textContent = Nd_d_v.childNodes[0].nodeValue;
      };
    };
  };
  if (Nd_d_v.children) {
    for(var i = 0;i < Nd_d_v.children.length;i++){
      if(Nd_d_v.children[i].tagName != "BR" && Nd_d_v.children[i].className != "visually-hidden" ){
        var cLEm = CRT_MK(Nd_d_v.children[i]);
        newElement.appendChild(cLEm);
      };
    };
  };
  return newElement;
};

/*--  ClK Categ  --*/
function CLKCTG(){
  document.getElementById("mobile-collection-filters").setAttribute("aria-hidden","false");
  document.getElementsByClassName("collection__toolbar-item--filter")[0].setAttribute("aria-expanded","true");
};

/*--  Accordion Toggle  --*/
function SPCTGL(thstgl){
  var tgt = thstgl.nextElementSibling;
  tgt.classList.toggle('spc-open');
  thstgl.classList.toggle('spc-tglpls');
};

function RDOCHK(rdod){
  var rdo_name = document.getElementById(rdod).parentElement.parentElement.parentElement;
  var rdo_inp = rdo_name.getElementsByClassName("SPC-CB");
  for(var a=0;a<rdo_inp.length;a++){
    if(rdo_inp[a].getAttribute("id") == rdod){
      if(rdo_inp[a].getAttribute("data-rdochk") == "ckd"){
        rdo_inp[a].setAttribute("data-rdochk","");
        rdo_inp[a].checked = false;
      }else{
        rdo_inp[a].setAttribute("data-rdochk","ckd");
      };
    }else{
      rdo_inp[a].setAttribute("data-rdochk","");
    };
  };
};

function cbunchk(){
  var inp_list = document.getElementById("SPC-inp_list").getElementsByClassName("SPC-CB");
  for(var L = 0;L < inp_list.length;L++){
    inp_list[L].checked = false;
  };
  var lbl_list = document.getElementById("SPC-inp_list").getElementsByClassName("SPC-cb_field-inp");
  for(var L = 0;L < lbl_list.length;L++){
    lbl_list[L].checked = false;
  };
};